import Content from 'components/layout/Content';

export const withContent = (Comp: any, extraProps = {}): any => (props: any) => (
  <Content {...props}>
    <Comp {...props} {...extraProps} />
  </Content>
);
